import { Summary } from './summary/summary'
import { YesterdayAtAGlance } from './yesterday-at-a-glance'
import { StorePerformance } from './store-performance/store-performance'
import { InsightsTab } from './utils'
import { useInsightsData } from 'hooks/insights/useInsightsData'
import type { Insight } from './types'
import { Grid } from '@design-systems/canvas-ui'

import { useDwellTime } from 'utils/analytics'
import { AudioPlayer } from './audio-player/audio-player'
import { useAudioData } from 'hooks/insights/useAudioData'

export const YesterdayTab = () => {
    useDwellTime('insights/yesterday')
    const { data, renderGuard } = useInsightsData()
    const { audio } = useAudioData()

    if (renderGuard) return renderGuard

    const daily = data?.daily_insights

    const insights = (daily?.insights ?? []).filter(
        (i) => !!i.title && !!i.summary,
    ) as Insight[]

    return (
        <Grid.Container
            className="hc8-ph-4x hc8-pt-3x hc8-pb-4x insights-container"
            align="start"
            direction="column"
            spacing="expanded"
        >
            {audio.url && (
                <Grid.Item className="hc8-wth-100">
                    <AudioPlayer />
                </Grid.Item>
            )}
            <Grid.Item className="hc8-wth-100">
                <Summary
                    tab={InsightsTab.Yesterday}
                    title={daily?.summary?.title ?? null}
                    summary={daily?.summary?.summary ?? null}
                    startDate={daily?.date}
                    showSummaryDetailsButton={false}
                />
            </Grid.Item>
            {insights.length > 0 && (
                <Grid.Item className="hc8-wth-100">
                    <YesterdayAtAGlance insights={insights} />
                </Grid.Item>
            )}
            <Grid.Item className="hc8-wth-100">
                <StorePerformance
                    pyramidData={daily?.sales_per_pyramid ?? []}
                    departmentData={daily?.sales_per_department ?? []}
                />
            </Grid.Item>
        </Grid.Container>
    )
}
